import moment from 'moment';
import BaseAccountController from '../../lib/controllers/BaseAccountController';

export default class ForgotUsernameController extends BaseAccountController {
	public static $inject: string[] = ['$scope', 'ForgotUsernameResource'];

	public emailErrorMessage: string;
	public generalError: string;
	public confirmationErrorMessage: string;
	public firstName: string;
	public lastName: string;
	public dob: string;
	public memberId: number;
	public emailAddress: string;
	public submitted: boolean;

	private readonly ForgotUsername: MyAccountApi.IForgotUsernameResource;

	constructor($scope: ng.IScope, ForgotUsernameResource: MyAccountApi.IForgotUsernameResource) {
		super($scope);
		this.ForgotUsername = ForgotUsernameResource;
	}

	public cancel(): void {
		window.history.go(-1);
	}

	public recoveryDataIsValid(form: ng.IFormController): boolean {
		let valid = form != null ? !form.$submitted : false;
		if (this.memberId) {
			valid = true;
		} else if ( this.firstName && this.lastName && this.dob) {
			valid = true;
		}

		return valid;
	}

	public submitRequest(form: ng.IFormController): void {
		this.generalError = '';

		const recoveryData = this.getRecoveryData();
		if (form.$valid && this.recoveryDataIsValid(form)) {
			this.ForgotUsername.submit(recoveryData,
			() => {
				this.submitted = true;
			},
			(failure: MyAccountApi.IServiceFailureResponse ) => {
				if (failure && failure.data && failure.data.validationErrors) {
					this.generalError = failure.data.validationErrors[0].message;
				} else {
					this.generalError = 'Server error while attempting to recover username';
				}
			});
		}
	}

	private getRecoveryData(): MyAccountApi.IForgotUsernameRecoveryPararms {
		const recoveryData: MyAccountApi.IForgotUsernameRecoveryPararms = {
			emailAddress: this.emailAddress,
			memberId: null,
			firstName: null,
			lastName: null,
			dob: null
		};

		if (this.memberId) {
			recoveryData.memberId = this.memberId;
		} else if (this.firstName && this.lastName && this.dob) {
			recoveryData.firstName = this.firstName;
			recoveryData.lastName = this.lastName;
			recoveryData.dob = {
				dateStr: moment(this.dob, 'MM/DD/YYYY').format('YYYY-MM-DD')
			};
		}

		return recoveryData;
	}
}
